import { LogoutIcon } from '../../constants/navigation.constants';

interface UserCardProps {
  user: any;
  onLogout: () => void;
}

export function UserCard({ user, onLogout }: UserCardProps) {
  const roleBg = user?.role === 'SUPER_ADMIN' ? 'rgba(0,117,141,0.18)' : user?.role === 'ADMIN' ? 'rgba(255,255,255,0.08)' : 'rgba(223,195,47,0.15)';
  const roleColor = user?.role === 'SUPER_ADMIN' ? '#60c9d8' : user?.role === 'ADMIN' ? 'rgba(255,255,255,0.55)' : '#e2c95a';
  const roleLabel = user?.role === 'SUPER_ADMIN' ? 'Super Admin' : user?.role === 'ADMIN' ? 'Administrateur' : 'Manager';

  return (
    <div className="admin-sidebar-footer">
      <div style={{ padding: '10px 12px', borderRadius: 7, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', marginBottom: 8 }}>
        <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', background: roleBg, color: roleColor, marginBottom: 7 }}>{roleLabel}</span>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.9)', marginBottom: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
        <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,0.35)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.email}</div>
      </div>
      <button onClick={onLogout} className="logout-btn" onMouseEnter={(e) => { e.currentTarget.style.color = '#fc8888'; e.currentTarget.style.background = 'rgba(239,68,68,0.08)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.35)'; e.currentTarget.style.background = 'transparent'; }} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '8px 12px', borderRadius: 6, border: 'none', background: 'transparent', color: 'rgba(255,255,255,0.35)', fontSize: 13, fontWeight: 500, cursor: 'pointer', transition: 'color 0.15s, background 0.15s', textAlign: 'left' }}>
        <LogoutIcon /> Déconnexion
      </button>
    </div>
  );
}
